"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumberPretty = void 0;
const phone_1 = __importDefault(require("phone"));
/**
 * Formats a phone number string to be in this format: +18175698900.
 * Returns `null` if the input is an invalid phone number.
 * See: https://github.com/AfterShip/phone
 */
function formatPhoneNumber(phoneNumber) {
    const result = phone_1.default(phoneNumber, {
        strictDetection: true,
        country: "",
        validateMobilePrefix: false,
    });
    return result.isValid ? result.phoneNumber : null;
}
exports.default = formatPhoneNumber;
function formatPhoneNumberPretty(phoneNumber) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    if (!formattedPhoneNumber) {
        return null;
    }
    // Drop the country code if it's a US number (country code is 1)
    if (formattedPhoneNumber.length === 12 && formattedPhoneNumber[1] === "1") {
        return (formattedPhoneNumber[2] +
            formattedPhoneNumber[3] +
            formattedPhoneNumber[4] +
            "-" +
            formattedPhoneNumber[5] +
            formattedPhoneNumber[6] +
            formattedPhoneNumber[7] +
            "-" +
            formattedPhoneNumber[8] +
            formattedPhoneNumber[9] +
            formattedPhoneNumber[10] +
            formattedPhoneNumber[11]);
    }
    const countryCodeLength = formatPhoneNumber.length - 12;
    const countryCode = formattedPhoneNumber.slice(1, countryCodeLength + 1);
    const remaining = formattedPhoneNumber.slice(countryCodeLength + 1);
    // Prepend with non-US country code (ex. +44 207-183-8750)
    return ("+" +
        countryCode +
        " " +
        remaining[0] +
        remaining[1] +
        remaining[2] +
        "-" +
        remaining[3] +
        remaining[4] +
        remaining[5] +
        "-" +
        remaining[6] +
        remaining[7] +
        remaining[8] +
        remaining[9]);
}
exports.formatPhoneNumberPretty = formatPhoneNumberPretty;
//# sourceMappingURL=data:application/json;base64,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